module.exports = __webpack_public_path__ + "static/media/network_error.e58aafbb.svg";